// Export data as TSV (Tab-Separated Values) format
// TSV is preferred over CSV because data may contain commas
export const exportCSV = (data: any[], filename: string): void => {
  // Use TSV format (Tab-Separated Values) to avoid issues with commas in data
  // Escape any tabs, newlines, and carriage returns in the data
  const escapeValue = (value: any): string => {
    const str = String(value || '');
    // Replace tabs with spaces, and escape newlines/carriage returns
    return str.replace(/\t/g, ' ').replace(/\r/g, '\\r').replace(/\n/g, '\\n');
  };
  
  const tsv = data.map((row: any[]) => 
    row.map((cell: any) => escapeValue(cell)).join('\t')
  ).join('\n');
  
  // Create a BOM (Byte Order Mark) for proper UTF-8 encoding in Excel
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + tsv], { type: 'text/tab-separated-values;charset=utf-8' });
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename.toLowerCase().replace(/\s+/g, '_')}.tsv`;
  link.click();
  
  // Clean up the object URL after download
  setTimeout(() => URL.revokeObjectURL(link.href), 100);
};